export default __webpack_public_path__ + "static/media/Nandy.86d47f5a.jpeg";